export const transactionsBooleans = (type) => {
  const isMine = type == "mine";
  const isTeam = type == "team";
  const isCompany = !isMine && !isTeam;
  return { isTeam, isMine, isCompany };
};
